export default {
  data() {
    return {
      type: null,
      type_not_found: false,
      apiModel: 'productDynamic',
    }
  },
  computed: {
    typeId() {
      return this.$route.params.typeId;
    },
  },
  async mounted() {
    await this.getType(this.typeId);
  },
  methods: {
    async getType(typeId) {
      try {
        console.log(this.apiModel);
        const { data } = await this.$api[this.apiModel].getType(typeId);
        this.type = {
          ...data.data,
        }
        this.setBreadcrumb(this.type.Type);
        this.$emit('type', this.type.Type);
      } catch (e) {
        console.error(e)
      } finally {
        if (!this.type) {
          this.type_not_found = true
        }
      }
    },
    async setBreadcrumb(text) {
      const item = this.$route.meta.breadcrumb.find(({dynamic}) => dynamic);

      if (!item) {
        return;
      }

      item.url = `/product-documents/${this.typeId}`;
      item.title = text

      // This forces a reload of the router
      // https://stackoverflow.com/questions/46838665/vue-router-dynamically-set-meta
      await this.$router.replace({query: {temp: Date.now()}})
      await this.$router.replace({query: {temp: undefined}})
    }

  },
};
